// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2M8dn","inner":"Footer_inner__bPTqM"};